/**
 * Minimal pub/sub for the variables/cart/customer/product update events
 * that the SDK's WebbridgeProvider subscribes to.
 *
 * Mirrors the surface tapcart-webbridge's EventManager exposes — just the
 * register/notify pair, not the full lifecycle. The SDK never calls
 * `unregister` directly, so the returned disposer is provided for our own
 * cleanup paths (e.g. provider unmount).
 */
export class EventBus {
    constructor() {
        this.handlers = new Map();
    }
    register(eventName, callback) {
        let set = this.handlers.get(eventName);
        if (!set) {
            set = new Set();
            this.handlers.set(eventName, set);
        }
        set.add(callback);
        return () => {
            var _a;
            (_a = this.handlers.get(eventName)) === null || _a === void 0 ? void 0 : _a.delete(callback);
        };
    }
    emit(eventName, data) {
        const callbacks = this.handlers.get(eventName);
        if (!callbacks)
            return;
        for (const cb of callbacks) {
            try {
                cb(data);
            }
            catch (err) {
                // Don't let one bad handler break the rest.
                console.error(`[storefront-bridge] event handler for "${eventName}" threw`, err);
            }
        }
    }
}
